// extracted by mini-css-extract-plugin
export default {"login":"SignUp_login__7F06s","login_container":"SignUp_login_container__RBVZA","btn_signin":"SignUp_btn_signin__xH0Fh","btn_createacc":"SignUp_btn_createacc__s1lJK"};